var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.locations,
      customMultiStyleParent: _vm.getcontainerStyle,
      loading: _vm.$apollo.queries.locations.loading,
      noOptionsText: "Start typing",
      placeholder: "Select location",
    },
    on: {
      search: (v) => (_vm.locationSearchString = v),
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }